<div class="app-date-picker-wrapper" [class.icon-only-wrapper]="iconOnly" [class.hide-trigger]="hideTrigger">
  <label *ngIf="label" class="app-date-picker-label">{{ label | translate }}</label>
  <p-datepicker
    [(ngModel)]="value"
    (ngModelChange)="onChange($event)"
    (onBlur)="onBlur()"
    [placeholder]="placeholder | translate"
    [disabled]="disabled"
    [showIcon]="showIcon"
    [iconDisplay]="'input'"
    [dateFormat]="yearOnly ? 'yy' : monthOnly ? 'MM' : dayOnly ? 'dd' : monthAndDayOnly ? 'dd.mm' : dateFormat"
    [view]="yearOnly ? 'year' : monthOnly ? 'month' : 'date'"
    [showTime]="showTime"
    [showClear]="showClear"
    [firstDayOfWeek]="firstDayOfWeek"
    [minDate]="minDate"
    [maxDate]="maxDate"
    [hourFormat]="hourFormat"
    [timeOnly]="timeOnly"
    [showSeconds]="showSeconds"
    [selectionMode]="selectionMode"
    [numberOfMonths]="numberOfMonths"
    (onYearChange)="yearChange($event)"
    (onMonthChange)="monthChange($event)"
    [autofocus]="false"
    styleClass="app-date-picker {{ iconOnly ? 'app-date-picker-icon-only' : 'w-full' }} {{ disabled ? 'disabled' : '' }}"
    appendTo="body"
    panelStyleClass="app-date-panel"
    inputId="calendar-24h"
  >

    <ng-template pTemplate="date" let-date>
    <span
      [class.disabled-date]="!isAllowed(date)"
      [style.padding-left]="'8px'"
      (click)="onDateCellClick($event, date)"
    >
      {{ date.day }}
    </span>
    </ng-template>

  </p-datepicker>
</div>
